'use client';

import SwapTextButton from '@/components/ui/SwapTextButton/SwapTextButton';
import { useSalesCallbackOptional } from '@/components/sales-callback/SalesCallbackProvider';
import { getStrapiPdfDownloadUrl } from '@/lib/strapi-media-url';

interface CompanyProfileDownloadCtaProps {
  href: string;
  text: string;
  ariaLabel: string;
  className?: string;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
}

export default function CompanyProfileDownloadCta({
  href,
  text,
  ariaLabel,
  className,
  target,
  rel,
}: CompanyProfileDownloadCtaProps) {
  const salesCallback = useSalesCallbackOptional();
  const resolvedHref = getStrapiPdfDownloadUrl(href) || href;
  const isPdfDownload = resolvedHref.startsWith('/api/media/download?');

  return (
    <SwapTextButton
      href={resolvedHref}
      text={text}
      hoverText={text}
      variant="filled"
      tone="brand"
      target={target ?? (isPdfDownload ? undefined : '_blank')}
      rel={rel}
      download={isPdfDownload}
      aria-label={ariaLabel}
      className={className}
      onClick={
        isPdfDownload
          ? undefined
          : () => {
              salesCallback?.openForm();
            }
      }
    />
  );
}
